import { OrderStatusAlias, OrderStatuses } from 'constants/orderStatuses';

import { OrderList } from 'types/embedded/order';

const RED_COLOR = '#FEEBEE';

const ColorConfig: Partial<Record<OrderStatusAlias, string>> = {
  [OrderStatuses.Failure]: RED_COLOR,
  [OrderStatuses.Expired]: RED_COLOR,
  [OrderStatuses.Cancelled]: RED_COLOR,
};

export const getRowStyle = (record: OrderList) =>
  record?.statusAlias && ColorConfig[record.statusAlias]
    ? { background: ColorConfig[record.statusAlias] }
    : { background: 'white' };
